<template>
	<HiringDateEdit
		:value="value"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import HiringDateEdit from "@/vue/job-profile/hiring-date/Edit"

export default {

	components: {
		HiringDateEdit,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},
}
</script>
